import { render } from "./DEILinksPage.vue?vue&type=template&id=8c1713b0"
import script from "./DEILinksPage.vue?vue&type=script&lang=js"
export * from "./DEILinksPage.vue?vue&type=script&lang=js"

import "./DEILinksPage.vue?vue&type=style&index=0&id=8c1713b0&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__